export default "__VITE_ASSET__DqvEyg2M__"